<template>
  <div
    class="data-table__header__row__cell"
    :class="'column-size__' + header?.size"
    :style="{ width: header?.size }"
    @click="handleSort"
  >
    <div>
      <div
        class="header-title"
        :style="{ cursor: header?.sort ? 'pointer' : 'default' }"
      >
        <h3>
          {{ header?.title }}
          <template v-if="header?.infoIcon">
            <svg-loader
              :id="'info-icon-' + header?.title"
              class="header-title-info-icon"
              src="/static/images/icon-info.svg"
            />
            <md-tooltip :md-direction="hint">
              {{ header?.infoIconTooltipText }}
            </md-tooltip>
          </template>
        </h3>
        <span v-if="header?.sort">
          <svg
            v-if="order === 'asc'"
            width="12"
            viewBox="0 0 24 24"
          >
            <path
              d="M12 4l-8 8h16z"
              fill="black"
            />
          </svg>
          <svg
            v-else-if="order === 'desc'"
            width="12"
            viewBox="0 0 24 24"
          >
            <path
              d="M12 20l8-8H4z"
              fill="black"
            />
          </svg>
        </span>
      </div>
      <p v-if="header?.subtitle">
        {{ header?.subtitle }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataTableHeader',
  props: {
    header: {
      type: Object,
      default: () => ({ title: '', value: '', sort: false, order: '', size: 20 })
    },
    sortOrder: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: 'top'
    }
  },
  data() {
    return {
      order: ''
    }
  },
  watch: {
    sortOrder: {
      handler(value) {
        this.order = value
      }
    }
  },
  methods: {
    handleSort() {
      if (!this.header.sort) return

      const nextOrder = {
        '': 'asc',
        asc: 'desc',
        desc: ''
      }

      this.order = nextOrder[this.order] || ''

      this.$emit('sort', { ...this.header, order: this.order })
    }
  }
}
</script>

<style scoped lang="scss">
  .data-table__header__row__cell {
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .header-title {
      display: flex;
      flex-direction: row;
      gap: 2px;
    }
  }
</style>